import { darken } from 'polished';
import styled, { css } from 'styled-components';

export const Container = styled.div``;

export const ContainerMenu = styled.div`
  width: 100%;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  z-index: 10;

  @media only screen and (max-width: 950px) {
    position: absolute;
    background: #fff;
    top: 60px;
    left: 0;
    cursor: pointer;
    transition: 0.6s;
    flex-direction: column;
    justify-content: flex-start;
    width: 100%;
    height: 0;
    gap: 8px;
    overflow: hidden;
    ${props =>
      props.isOpenMenu &&
      css`
        padding: 0px 0px 18px;
        height: 400px;
      `};
  }

  .container-items-seeMore {
    @media only screen and (max-width: 950px) {
      width: 100%;
    }
  }

  a.btn-sendcurriculum {
    /* background: ${props => props.primaryColor || '#36397A'}; */
    background: #475467;

    width: 260px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 6px;
    text-decoration: none;
    :hover {
      background: ${darken(0.1, '#475467')};
    }
    color: #fff;
    @media only screen and (max-width: 950px) {
      margin-top: 25px;
    }
  }

  a.btn-register {
    background: ${props => props.primaryColor || '#36397A'};

    width: 260px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 6px;
    text-decoration: none;
    :hover {
      background: ${props => darken(0.1, props.primaryColor || '#36397A')};
    }
    color: #fff;
    @media only screen and (max-width: 950px) {
      margin-top: 25px;
    }
  }
`;

export const BtnMenu = styled.div`
  display: none;
  @media only screen and (max-width: 950px) {
    display: block;
    svg {
      width: 12px;
    }
  }
`;

export const ItemMenu = styled.a`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  text-transform: uppercase;
  color: ${props => props.color || '#667085'};
  padding: 8px 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  text-decoration: none;
  cursor: pointer;
  svg {
    display: ${props => (props.login ? 'block' : 'none')};
    margin-left: 8px;
    width: 12px;
  }

  @media only screen and (max-width: 950px) {
    width: 100%;
    color: #475467;
    transition: 0.6s;
    font-size: 16px;
    :hover {
        background: #E4E7EC;
    }
    svg {
      display: block;
    }

    ${props =>
      props.login &&
      css`
        margin-top: 25px;
      `}

    }
  }
`;

export const SeeMore = styled.div`
  display: flex;
  flex-direction: column;
  position: absolute;
  gap: 8px;
  top: 60px;
  left: 0;
  overflow: hidden;
  background: #fff;
  z-index: 10;

  @media only screen and (min-width: 950px) {
    height: ${props => (props.isOpenSeeMore ? 'auto' : '0px')};
    a {
      :hover {
        background: #e4e7ec;
      }
    }
  }

  @media only screen and (max-width: 950px) {
    width: 100%;
    position: relative;
    top: 0px;
    left: 0px;
  }
`;

export const BtnSeeMore = styled.a`
  position: relative;
  font-style: normal;
  font-weight: 400;
  font-size: 14px !important;
  line-height: 20px;
  text-transform: uppercase;
  color: #667085;
  padding: 8px 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 120px;
  cursor: pointer;
  svg {
    margin-left: 8px;
    width: 12px;
  }

  @media only screen and (max-width: 950px) {
    display: none;
  }
`;
